// src/app/constants/grid-themes.ts
import { themeQuartz } from 'ag-grid-community';

/**
 * Custom AG Grid theme with specific header styling
 * Use this constant in components that need AG Grid tables
 */
export const myCustomTheme = themeQuartz.withParams({
  // Header customization
  headerHeight: 30,
  headerTextColor: 'white',
  headerBackgroundColor: '#0099ab',
});

/**
 * Alternative theme with a different color scheme
 * For secondary or accent tables
 */
// export const secondaryTheme = themeQuartz.withParams({
//   headerHeight: 30,
//   headerForegroundColor: 'white',
//   headerBackgroundColor: '#444444',
//   borderColor: '#dddddd'
// });

// /**
//  * Compact theme with smaller rows and less padding
//  * For data-dense tables with many rows
//  */
// export const compactTheme = themeQuartz.withParams({
//   headerHeight: 24,
//   rowHeight: 24,
//   cellHorizontalPadding: 4,
//   headerForegroundColor: 'white',
//   headerBackgroundColor: '#0099ab'
// });